import { Icon } from "@iconify/react";
import React from "react";
import { formatRelativeTime } from "../../../utils/adapters";

type Props = {
  userName: string;
  userAvatar: string | null;
  createdAt?: string;
  isOwner?: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
};

const PostHeader: React.FC<Props> = ({
  userName,
  userAvatar,
  createdAt,
  isOwner,
  onEdit,
  onDelete,
}) => {
  const [menuOpen, setMenuOpen] = React.useState(false);

  // ✅ fallback: صورة author أو ui-avatars بـ initials
  const avatarSrc =
    userAvatar ||
    `https://ui-avatars.com/api/?name=${encodeURIComponent(
      userName ?? "User"
    )}&background=ccc&color=000&size=128`;

  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center space-x-3">
        <img
          src={avatarSrc}
          alt={userName}
          className="w-10 h-10 rounded-full object-cover"
          onError={(e) => {
            // fallback لو الصورة فشلت تحميل
            (e.target as HTMLImageElement).src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
              userName ?? "User"
            )}&background=10b981&color=fff&size=128`;
          }}
        />

        <div className="flex flex-col">
          <span className="font-semibold dark:text-white text-gray-800 cursor-pointer">
            {userName}
          </span>

          {createdAt && (
            <div className="flex items-center space-x-1 dark:text-muted text-sm text-gray-500">
              <Icon icon="mdi:clock-outline" className="w-3 h-3" />
              <span>{formatRelativeTime(createdAt)}</span>
            </div>
          )}
        </div>
      </div>

      {isOwner && (
        <div className="relative">
          <button
            onClick={() => setMenuOpen((v) => !v)}
            className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <Icon icon="mdi:dots-vertical" className="w-5 h-5" />
          </button>

          {menuOpen && (
            <>
              <div
                className="fixed inset-0 z-10"
                onClick={() => setMenuOpen(false)}
              />
              <div className="absolute right-0 mt-1 w-32 bg-white dark:bg-deepSlate rounded-lg shadow-lg py-1 z-20">
                <button
                  onClick={() => {
                    setMenuOpen(false);
                    onEdit?.();
                  }}
                  className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  Edit
                </button>

                <button
                  onClick={() => {
                    setMenuOpen(false);
                    onDelete?.();
                  }}
                  className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  Delete
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(PostHeader);